export default __webpack_public_path__ + "static/media/1219.291eacd7.jpg";